class Auth {
    constructor() {}

    login(creds) {
        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/login', creds);
        });
    }

    register(creds) {
        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/register', creds);
        });
    }

    sendForgotPasswordLink(email) {
        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/forgot-password', { email: email });
        });
    }

    resetPassword(creds) {
        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/reset-password', creds);
        });
    }

    logout() {
        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/logout');
        });
    }

    enableSms2fa(phone) {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };
        return axios.get('/sanctum/csrf-cookie').then((response) => {
            return axios.post(
                '/api/2fa/enableSms2fa',
                { phone: phone },
                headers
            );
        });
    }

    submitTwoFA(code) {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };
        return axios.get('/sanctum/csrf-cookie').then((response) => {
            return axios.post('/api/2fa', code, headers);
        });
    }

    validatePhoneNumber(code) {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };
        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/api/2fa/validate-phone-number', code, headers);
        });
    }

    resendTwoFA() {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/api/2fa/reset', headers);
    }

    resendSmsTwoFA(phone) {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/sanctum/csrf-cookie').then((response) => {
            return axios.post('/api/2fa/resend', { phone: phone }, headers);
        });
    }

    changePassword(code) {
        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/settings/change-password', code);
        });
    }

    async confirmPassword(password) {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post(
                '/user/confirm-password',
                {
                    password: password,
                },
                headers
            );
        });
    }

    async enableTwoFactor() {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post(
                '/api/user/two-factor-authentication',
                {},
                headers
            );
        });
    }

    async get2faQrCode() {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/api/two-factor-qr-code', headers);
    }

    async verify2faQrCode(code) {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post(
                '/api/user/confirmed-two-factor-authentication',
                { code: code },
                headers
            );
        });
    }

    async getRecoveryCodes() {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/api/user/two-factor-recovery-codes', headers);
    }

    async twoFactorChallenge(data) {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/api/user/two-factor-challenge', data, headers);
        });
    }

    async disableTwoFactor() {
        const data = { _method: 'delete' };
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post(
                '/api/user/two-factor-authentication',
                data,
                headers
            );
        });
    }

    async updateUser(data) {
        const token = localStorage.getItem('_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.put('/user/profile-information', data, headers);
        });
    }
}
export default new Auth();
